import React from 'react';
import { Link } from 'react-router-dom';
import * as moment from "moment";
import { Badge } from 'reactstrap';

const formateDate = (date, format) => {
    const dateFormat = format ? format : "DD MMM Y";
    const date1 = moment(new Date(date)).format(dateFormat);
    return date1;
};
const toLowerCase1 = str => {
    return (
      str === "" || str === undefined ? "" : str.toLowerCase()
    );
  };

const CheckBox = (cell) => {
    return cell.value ? cell.value : '';
};

const OrderId = (cell) => {
    return (
        <Link to="#" className="text-body fw-bold">{cell.value ? cell.value : ''}</Link>
    );
};

const BillingName = (cell) => {
    return cell.value ? cell.value : '';
};

const Date = (cell) => {
    return cell.value ? cell.value : '';
};

const Total = (cell) => {
    return cell.value ? cell.value : '';
};

const PaymentStatus = (cell) => {
    return (
        <Badge
          className={"font-size-11 badge-soft-" + 
          (cell.value === "PAID" ? "success" : "danger" && cell.value === "PENDING" ? "warning" : "danger")}          
        >
          {cell.value}
        </Badge>
    )
};
const LogStatus = (cell) => {
    return (
        <Badge
          className={"font-size-11 badge-soft-" + 
          (cell.value === "SUCCESS" ? "success" : "danger" && cell.value === "FAILED" ? "warning" : "danger")}          
        >
          {cell.value}
        </Badge>
    )
};

const getStatusColor = (status) => {
  switch (status) {
    case "Order Placed":
      return "primary";

    case "Order in Progress":
      return "info";

    case "Delivered":
      return "success";

    case "Pending":
      return "warning";

    case "Cancel":
      return "danger";

    default:
      return "secondary";
  }
};

const OrderStatus = (cell) => {
  return (
    <Badge className={`font-size-11 badge-soft-${getStatusColor(cell.value)}`}>
      {cell.value}
    </Badge>
  );
};
const OrderdStatus = ({ value }) => {
  return (
    <Badge className={`font-size-11 badge-soft-${getStatusColor(value)}`}>
      {value}
    </Badge>
  );
};
const PaymentMethod = (cell) => {
    return (
        <span>
        <i
        className={
          (cell.value === "Paypal" ? "fab fa-cc-paypal me-1" : "" || 
          cell.value === "COD" ? "fab fas fa-money-bill-alt me-1" : "" ||
          cell.value === "Mastercard" ? "fab fa-cc-mastercard me-1" : "" ||
          cell.value === "Visa" ? "fab fa-cc-visa me-1" : ""
          )}
          />{" "}
            {cell.value}
        </span>
    )
};
export {
    CheckBox,
    OrderId,
    BillingName,
    Date,
    Total,
    OrderStatus,
    OrderdStatus,
    PaymentStatus,
    LogStatus,
    PaymentMethod
};